/**
 * Fabian Favourites — DEMO behaviour (localStorage, no backend).
 *
 * For client review. Favourites live in localStorage under "fabian_favourites"
 * as an array of {variantId, productUrl, title, variantTitle, image, price},
 * newest-first, de-duped, capped. Three jobs:
 *   1. Toggle on ♥ click (and reflect state instantly).
 *   2. On load, mark any ♥ whose variant is already saved.
 *   3. Render the favourites page (#fabian-favourites-list) from localStorage.
 *
 * Swap target: replace this file with the App Proxy fetch version when the
 * Vercel backend goes live. The button markup + page container stay the same.
 */
(function () {
  // The snippet injects this script once per product card, so guard against
  // running (and attaching a second MutationObserver) more than once per page.
  if (window.__fabFavInit) return;
  window.__fabFavInit = true;

  var KEY = 'fabian_favourites';
  var MAX = 250;

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }
  function isSaved(list, variantId) {
    return list.some(function (it) { return it.variantId === variantId; });
  }
  // add newest-first if absent, remove if present; returns true if now saved.
  function toggle(item) {
    var list = read();
    if (isSaved(list, item.variantId)) {
      write(list.filter(function (it) { return it.variantId !== item.variantId; }));
      return false;
    }
    var deduped = list.filter(function (it) { return it.variantId !== item.variantId; });
    write([item].concat(deduped).slice(0, MAX));
    return true;
  }

  // On the PDP the button sits outside the product form; data-form-id names it.
  function formFor(button) {
    var id = button.getAttribute('data-form-id');
    if (id) return document.getElementById(id);
    return button.closest('product-form, form[action*="/cart/add"]');
  }

  // On the PDP the selected variant changes — read the live id from the product
  // form, falling back to the button's rendered id (cards).
  function liveVariantId(button) {
    var form = formFor(button);
    if (form) {
      var input = form.querySelector('[name="id"]');
      if (input && input.value) return input.value;
    }
    return button.getAttribute('data-variant-id') || '';
  }

  // The variant data Dawn's picker uses, for when the buyer picked another variant than the
  // one the button was rendered with.
  function pageVariant(button, variantId) {
    var id = button.getAttribute('data-form-id');
    if (!id) return null;
    var json = document.querySelector('#variant-selects-' + id.replace('product-form-', '') + ' script[type="application/json"]');
    if (!json) return null;
    try {
      return JSON.parse(json.textContent).find(function (v) { return String(v.id) === String(variantId); }) || null;
    } catch (e) { return null; }
  }

  function itemFromButton(button) {
    var variantId = liveVariantId(button);
    var item = {
      variantId: variantId,
      productUrl: button.getAttribute('data-product-url') || '',
      title: button.getAttribute('data-title') || '',
      variantTitle: button.getAttribute('data-variant-title') || '',
      image: button.getAttribute('data-image') || '',
      price: button.getAttribute('data-price') || ''
    };
    if (variantId === button.getAttribute('data-variant-id')) return item;
    var variant = pageVariant(button, variantId);
    if (variant) {
      item.productUrl = window.location.pathname + '?variant=' + variantId;
      item.variantTitle = variant.title || item.variantTitle;
      if (variant.featured_image && variant.featured_image.src) {
        item.image = variant.featured_image.src + (variant.featured_image.src.indexOf('?') === -1 ? '?' : '&') + 'width=400';
      }
      // Same currency as the rendered price; only the amount changes.
      var symbol = (item.price.match(/^[^\d]*/) || [''])[0];
      if (typeof variant.price === 'number') item.price = symbol + (variant.price / 100).toFixed(2);
    }
    return item;
  }

  function setState(button, saved) {
    button.classList.toggle('favourite-button--active', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = saved ? 'Added to favorites' : 'Add to favorites';
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
    // Update the visible label text if the button has one (product card / PDP).
    // Only write when it actually changes — writing textContent is a DOM
    // mutation, and an unconditional write feeds the MutationObserver loop.
    var textEl = button.querySelector('.favourite-button__text');
    if (textEl && textEl.textContent !== label) textEl.textContent = label;
  }

  function syncButton(button) {
    setState(button, isSaved(read(), liveVariantId(button)));
  }

  function doToggle(button) {
    var nowSaved = toggle(itemFromButton(button));
    setState(button, nowSaved);
    renderPage(); // keep the favourites page live if it's on screen
  }

  function onClick(event) {
    // Direct click / keyboard activation where the button is the actual target.
    event.preventDefault();
    event.stopPropagation();
    doToggle(event.currentTarget);
  }

  // Document-level capture handler: Dawn cards lay a transparent link overlay
  // across the whole card, and depending on the section's stacking context it
  // can sit ABOVE the heart and swallow the click (z-index doesn't always win).
  // Catch the click before it reaches that overlay's navigation by hit-testing
  // the cursor against each favourite button's box. Stacking-context proof.
  function onCaptureClick(event) {
    // If the real target is already our button, the normal onClick handles it.
    if (event.target.closest && event.target.closest('[data-favourite-button]')) return;
    // Keyboard-triggered clicks have no real coordinates — skip (handled above).
    if (!event.clientX && !event.clientY) return;
    var btns = document.querySelectorAll('[data-favourite-button]');
    for (var i = 0; i < btns.length; i++) {
      var r = btns[i].getBoundingClientRect();
      if (event.clientX >= r.left && event.clientX <= r.right &&
          event.clientY >= r.top && event.clientY <= r.bottom) {
        event.preventDefault();
        event.stopPropagation();
        doToggle(btns[i]);
        return;
      }
    }
  }

  function bind(root) {
    (root || document).querySelectorAll('[data-favourite-button]').forEach(function (btn) {
      if (!btn.__favBound) { btn.__favBound = true; btn.addEventListener('click', onClick); }
      syncButton(btn);
    });
    // Re-sync state when a PDP variant selection changes.
    (root || document).querySelectorAll('product-form, form[action*="/cart/add"]').forEach(function (form) {
      if (!form.__favChange) {
        form.__favChange = true;
        form.addEventListener('change', function () {
          form.querySelectorAll('[data-favourite-button]').forEach(syncButton);
        });
      }
    });
  }

  // PDP buttons outside the form: Dawn fires change on the form's id input when the variant moves.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.name !== 'id' || !target.form || !target.form.id) return;
    document.querySelectorAll('[data-favourite-button][data-form-id="' + target.form.id + '"]').forEach(syncButton);
  });

  // ---- favourites page rendering ----
  function renderPage() {
    var host = document.getElementById('fabian-favourites-list');
    if (!host) return;
    var list = read();
    if (!list.length) {
      host.innerHTML = '<p class="favourites-page__empty">You haven\'t saved anything yet. Tap the ♥ on any product to save it here.</p>';
      return;
    }
    var html = '<ul class="favourites-grid" role="list">' + list.map(function (it) {
      var img = it.image ? '<img class="favourites-grid__img" loading="lazy" src="' + esc(it.image) + '" alt="' + esc(it.title) + '">' : '';
      var variant = (it.variantTitle && it.variantTitle.indexOf('Default') === -1)
        ? '<span class="favourites-grid__variant">' + esc(it.variantTitle) + '</span>' : '';
      return '<li class="favourites-grid__item">' +
        '<a class="favourites-grid__link" href="' + esc(it.productUrl) + '">' + img +
          '<span class="favourites-grid__title">' + esc(it.title) + '</span>' + variant +
          '<span class="favourites-grid__price">' + esc(it.price) + '</span>' +
        '</a>' +
        '<button type="button" class="favourite-button favourite-button--active" data-favourite-remove="' + esc(it.variantId) + '" aria-label="Remove from favourites" title="Remove from favourites">' +
          '<svg class="favourite-button__icon favourite-button__icon--filled" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path fill="currentColor" d="M12 20.5l-1.45-1.32C5.4 14.36 2 11.28 2 7.5 2 5 3.98 3 6.5 3c1.74 0 3.41.81 4.5 2.09C12.09 3.81 13.76 3 15.5 3 18.02 3 20 5 20 7.5c0 3.78-3.4 6.86-8.55 11.68L12 20.5z"/></svg>' +
        '</button>' +
      '</li>';
    }).join('') + '</ul>';
    host.innerHTML = html;

    host.querySelectorAll('[data-favourite-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-favourite-remove');
        write(read().filter(function (it) { return it.variantId !== id; }));
        renderPage();
        // reflect on any matching buttons elsewhere on the page
        document.querySelectorAll('[data-favourite-button]').forEach(syncButton);
      });
    });
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var observer = null;
  function observe() {
    if (observer) observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
  function onMutations(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        // Pause observation while we (re)bind, so our own DOM writes (the button
        // label text) can't retrigger this callback — that feedback loop is what
        // froze the product page.
        observer.disconnect();
        bind(document);
        observe();
        return;
      }
    }
  }
  function start() {
    bind(document);
    renderPage();
    // Capture-phase, so we run before the card overlay's link navigates.
    document.addEventListener('click', onCaptureClick, true);
    if (window.MutationObserver) { observer = new MutationObserver(onMutations); observe(); }
  }
  // The script may load before or after DOMContentLoaded (it's injected inline
  // by the snippet), so handle both.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
